/**
 * Created by anatolij on 06.10.2026
 */

RewardsConfig.RoyalLeague = [
    {
        stickers: 15,
        unlimitedLives: "390 minutes",
        boosters: {
            cheap: 1,
            before_cheap: 1,
            medium: 1,
            before_medium: 1,
            expensive: 1,
            before_expensive: 1
        }
    },
    {
        unlimitedLives: "15 minutes",
        boosters: {
            medium: 1,
            before_medium: 1,
            expensive: 1,
            before_expensive: 1
        }
    },
    {
        unlimitedLives: "10 minutes",
        boosters: {
            cheap: 1,
            before_cheap: 1,
            medium: 1,
            before_medium: 1
        }
    },
    {
        boosters: { expensive: 1, before_expensive: 1 }
    },
    {
        boosters: { expensive: 1, before_expensive: 1 }
    },
    {
        boosters: { medium: 1, before_medium: 1 }
    },
    {
        boosters: { medium: 1, before_medium: 1 }
    },
    {
        boosters: { medium: 1, before_medium: 1 }
    },
    {
        boosters: { medium: 1, before_medium: 1 }
    },
    {
        boosters: { medium: 1, before_medium: 1 }
    }
];

RewardsConfig.RoyalLeagueStages = [
    { points: 10, prize: { boosters: { cheap: 1, before_cheap: 1 } } },
    { points: 20, prize: { hard: 400 } },
    { points: 60, prize: { unlimitedLives: "10 minutes", boosters: { before_medium: 1 } } },
    { points: 120, prize: { boosters: { medium: 1 } } },
    { points: 200, prize: { stickers: 2, boosters: { cheap: 2, medium: 1 } } },
    { points: 350, prize: { hard: 600 } },
    { points: 600, prize: { boosters: { expensive: 1, before_expensive: 1 } } },
    { points: 800, prize: { unlimitedLives: "15 minutes" } },
    { points: 1200, prize: { boosters: { cheap: 1, before_cheap: 1, medium: 1 } } },
    { points: 1500, prize: { unlimitedLives: "3 hours", stickers: 6, boosters: { medium: 1 } } },
    { points: 1550, prize: { hard: 800 } },
    { points: 1700, prize: { boosters: { before_medium: 1, expensive: 1, before_expensive: 1 } } },
    { points: 1750, prize: { unlimitedLives: "30 minutes" } },
    {
        points: 1900,
        prize: {
            boosters: {
                cheap: 1,
                before_cheap: 1,
                medium: 1,
                before_medium: 1,
                expensive: 1,
                before_expensive: 1
            }
        }
    },
    { points: 2000, prize: { hard: 2000 } }
];
